export default __webpack_public_path__ + "static/media/footerEvo.89582fb4.svg";